import { APICallV2Get } from 'reactApp/api/APICall';

/** Запрос за результатами поиска */
export class SearchApiCall extends APICallV2Get {
    _method = 'folder/find';
}
